<template>
    <MainContent
        title="Detalle del grupo de precios"
        format="card"
    >
        <template v-if="grupo" slot="header">
            <h4 class="card-title">
                {{ grupo.name }}
            </h4>
            <div class="card-tools">
                <AddPrecioModal
                    v-if="!loading"
                    :grupo_id="grupo.id"
                    @actualizar="getGrupo()"
                />
            </div>            
        </template>
        <template v-if="grupo" slot="content">
            <b-row>
                <b-col cols="12">
                    <b-table
                        :items="grupo.descuentos"
                        :fields="fields"
                        :show-empty="true"
                        :busy="loading"
                    >
                        <template #empty="">
                            <h5 class="text-center">No hay ningún precio disponible.</h5>                                               
                        </template>
                        <template #cell(opciones)="data">
                            <b-button @click="borrar(data.item.id)">Borrar</b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent.vue'
    import AddPrecioModal from './modals/AddPrecioModal.vue'

    export default {
        props: ['grupo_id'],
        data() {
            return {
                grupo: null,
                loading: false,
                fields: [
                    {
                        key: 'descripcion',
                        label: 'Nombre'
                    },
                    {
                        key: 'opciones',
                        label: 'Opciones'
                    },
                ],
            }
        },
        mounted() {
            this.getGrupo();
        },
        methods: {
            getGrupo() {
                const params = {
                    filters : this.filters,
                    lista_id: this.$store.getters.getListaId,
                    grupo_id: this.grupo_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.precios.grupos.show'), params).then(res => {
                    this.grupo = res.data.data;
                });
            },
            borrar(descuento_id) {
                this.loading = true;
                const params = {
                    filters : this.filters,
                    lista_id: this.$store.getters.getListaId,
                    grupo_id: this.grupo_id,
                    descuento_id: descuento_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.precios.grupos.descuentos.delete'), params).then(res => {
                    this.getGrupo();
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        components: {
            MainContent, AddPrecioModal
        }
    }
</script>